import { useError } from "../../context/useErrorContext"
import { GetRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { EAccountPlansType } from "../../Enum/EAccountPlansType"
import { EResellerCommissionDurationType } from "../../Enum/EResellerCommissionDurationType"
import { useTranslation } from "react-i18next"

export interface ResellerClient {
  id: number
  companyName: string
  subscriptionStatus: string
  planType: EAccountPlansType
  linkedAtUtc: string
  commissionPercentageSnapshot: number
  commissionDurationTypeSnapshot: EResellerCommissionDurationType
  commissionEndsAtUtc: string | null
  isCommissionActive: boolean
}

export const useGetResellerClients = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const handleGetResellerClients = async (onSuccess: (clients: ResellerClient[]) => void) => {
    try {
      const response = await GetRequest<ResellerClient[]>(API_ROUTES.RESELLER.CLIENTS, ERequestType.Reseller)

      if (response.success && response.data) {
        onSuccess(response.data)

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    }
  }

  return { handleGetResellerClients }
}
